<template>
  <a-spin :spinning="loading">
    <a-card :bordered="false">
      <div>
        <a-form :form="form" >
          <a-row>
            <a-col :span="24">
              <a-divider orientation="left">
                合同信息
              </a-divider>
            </a-col>
            <a-col :span="12">
              <a-form-item label="系统编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['number']" disabled/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="合同号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['contract_number']" disabled/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="合同名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input allow-clear v-decorator="['name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="名称" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="客户" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  mode="multiple"
                  option-label-prop="tt"
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="null"
                  show-search
                  v-decorator="[
                    'client_ids',
                    {
                      rules: [
                        { required: true, message: '选择客户' },
                      ],
                    },
                  ]"
                  placeholder="请输入客户"
                  :default-active-first-option="false"
                  @search="this.clientSearch"
                  @change="handleClientChange"
                >
                  <a-select-option v-for="d in clientList" :key="d.client_id" :tt="d.client">
                    {{ d.client }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="担保方式" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  allow-clear
                  v-decorator="[
                    'guarantee_method',
                    {
                      rules: [
                        { required: true, message: '' },
                      ],
                    },
                  ]"
                  placeholder="请选择"
                >
                  <a-select-option v-for="(item, key) in guaranteeMethodList" :key="key" :value="key">
                    {{ item }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="存放地" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input allow-clear v-decorator="['storage_location', {rules: [{required: false, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="存放地"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="抵押物" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input allow-clear v-decorator="['collateral', {rules: [{required: false, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="抵押物"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="质押物" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input allow-clear v-decorator="['pledged_goods', {rules: [{required: false, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="质押物"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="抵/质押货物价值" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input allow-clear v-decorator="['collateral_pledged_goods_value', {rules: [{required: false, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="抵/质押货物价值"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="登记方式" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input allow-clear v-decorator="['registration_method', {rules: [{required: false, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="登记方式"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="担保期限" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-range-picker @change="time" format="YYYY-MM-DD" style="width: 100%" v-decorator="['guarantee_period', {rules: [{required: false, message: '必填项，请填写信息'}]}]">
                  <template slot="dateRender" slot-scope="current">
                    <div class="ant-calendar-date" :style="getCurrentStyle(current)">
                      {{ current.date() }}
                    </div>
                  </template>
                </a-range-picker>
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="false">
              <a-form-item label="已存档" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-switch v-decorator="['is_archived', { valuePropName: 'checked' }]" checked-children="是" un-checked-children="否"/>
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="false">
              <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-textarea :rows="4" v-decorator="['remark', {rules: [{required: false, message: '必填项，请填写信息'}]}]" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-form-item v-bind="buttonCol">
            <a-row>
              <a-col offset="8" span="6">
                <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
              </a-col>
              <a-col span="10">
                <a-button @click="handleGoBack">返回</a-button>
              </a-col>
            </a-row>
          </a-form-item>
        </a-form>
      </div>
    </a-card>
  </a-spin>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import { guarantee_contract_list, guarantee_contract_update } from '@/api/trade_guarantee_contract'
import { project_client_list } from '@/api/trade_project_client'
import debounce from 'lodash/debounce'
export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    this.clientSearch = debounce(this.handleClientSearch, 800)
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      sell_contract_id: 0,
      type: '12',
      data: {},
      loading: false,
      clientList: [],
      guarantee_period_start_date: undefined,
      guarantee_period_end_date: undefined,
      fields: ['number', 'contract_number', 'name', 'client_ids'],
      guarantee_fields: ['guarantee_method', 'storage_location',
        'collateral', 'pledged_goods', 'guarantee_period', 'collateral_pledged_goods_value', 'registration_method'],
      guaranteeMethodList: this.$Dictionaries.guarantee_method,
      pricingCurrency: undefined
    }
  },
  mounted () {
    this.loadContract()
  },
  computed: {
    isCommon () {
      return false
    },
    validGuaranteeMethodKeys () {
      return Object.keys(this.guaranteeMethodList).map(Number)
    }
  },
  methods: {
    moment,
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    loadContract () {
      this.loading = false
      this.fields.push(...this.guarantee_fields)
      guarantee_contract_list({ id: this.$route.params.id }).then(res => {
        const list = res.data.entries
        if (list && list.length > 0) {
          this.data = list[0]
          this.id = this.data.id
          this.loadEditInfo(this.data)
          this.handleClientSearch(undefined)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleClientSearch (value) {
      project_client_list({ name: value, project_id: this.data.project_id }).then((res) => {
        const result = res.data.entries || []
        this.clientList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      })
    },
    handleClientChange (value) {
      if (value === undefined) {
        this.handleClientSearch(value)
      }
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values, err)
        if (!err) {
          values['sell_contract_id'] = this.sell_contract_id
          if (this.guarantee_period_start_date !== '' && this.guarantee_period_end_date !== '') {
            values['guarantee_period_start_date'] = this.guarantee_period_start_date
            values['guarantee_period_end_date'] = this.guarantee_period_end_date
          }
          this.loading = true
          guarantee_contract_update(values, this.id).then((res) => {
            if (res.code === 1000) {
              this.handleGoBack()
              console.log(res, '修改成功')
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      const formData = pick(data, this.fields)
      // 处理 guarantee_method：仅当值在合法范围内才保留，否则设为 undefined
      const validGuaranteeMethods = this.validGuaranteeMethodKeys // 缓存好的合法 key 数组
      if (validGuaranteeMethods.includes(data.guarantee_method)) {
        formData.guarantee_method = String(data.guarantee_method) // 转为字符串（如用于 Select 组件）
      } else {
        formData.guarantee_method = undefined
      }

      // 处理 guarantee_period 日期范围
      const hasValidPeriod =
        data.guarantee_period_start_date &&
        data.guarantee_period_start_date !== '1970-01-01' &&
        data.guarantee_period_end_date &&
        data.guarantee_period_end_date !== '1970-01-01'
      if (hasValidPeriod) {
        formData.guarantee_period = [
          moment(data.guarantee_period_start_date),
          moment(data.guarantee_period_end_date) ]
        this.guarantee_period_start_date = data.guarantee_period_start_date
        this.guarantee_period_end_date = data.guarantee_period_end_date
      } else {
        formData.guarantee_period = undefined
      }
      console.log('formData', formData)
      this.sell_contract_id = data.sell_contract_id
      form.setFieldsValue(formData)
    },
    time (dates, dateStrings) {
      if (dates.length > 0) {
        this.guarantee_period_start_date = dateStrings[0]
        this.guarantee_period_end_date = dateStrings[1]
      } else {
        this.guarantee_period_start_date = '1970-01-01'
        this.guarantee_period_end_date = '1970-01-01'
      }
      console.log(this.dateStrings, '时间', dates)
    },
    getCurrentStyle (current, today) {
      const style = {}
      if (current.date() === 1) {
        style.border = '1px solid #1890ff'
        style.borderRadius = '50%'
      }
      return style
    }
  }
}
</script>
